import { Container } from '@sonans/components'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, AppState, IProgamType } from '@/types'
import { useNavigate, useParams } from 'react-router-dom'
import { setSelectedProgramType } from '@/reducers/programTypes'
import { setSelectedEducationalProgram } from '@/reducers/educationalPrograms'
import { resetGrades, setTwentyThreeFiveRule } from '@/reducers/grades'
import { fetchAdditionalCourses, fetchCourses } from '@/reducers/courses'
import { AppLayout } from '@/components/UI/AppLayout'
import StoredResultsList from '@/components/UI/StoredResultsList'
import { useEffect } from 'react'
import { setReferenceCode, setUserAlias } from '@/reducers/referenceCode'
import { Text } from '@/components/UI/Text'
import { Button } from '@sonans/components'

export function ProgramTypes() {
    const { data } = useSelector((state: AppState) => state.programTypes)

    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const { referenceCode } = useParams()

    function handleProgramTypeClick(programType: IProgamType) {
        if (programType.name === '23/5-regelen') {
            dispatch(setSelectedProgramType(programType))
            dispatch(setSelectedEducationalProgram(null))
            dispatch(setTwentyThreeFiveRule(true))
            dispatch(resetGrades())
            dispatch(fetchCourses())
            dispatch(fetchAdditionalCourses())
            navigate('/karakterer')
        } else {
            dispatch(setSelectedProgramType(programType))
            dispatch(setSelectedEducationalProgram(null))
            dispatch(setTwentyThreeFiveRule(false))
            navigate('/utdanningsprogram')
        }
    }

    useEffect(() => {
        if (referenceCode) {
            navigate(`/karakterer/${referenceCode}`)
        }
        dispatch(setReferenceCode(''))
        dispatch(setUserAlias(''))
    }, [dispatch, navigate])

    return (
        <AppLayout>
            <section className="animate-reveal mb-14">
                <Container className="flex flex-col gap-10">
                    <div className="my-4 sm:my-12 flex items-center justify-center">
                        <Text type="title" center>
                            Hva gikk du på videregående?
                        </Text>
                    </div>
                    <div className="flex flex-col md:flex-row gap-4 justify-center items-center mb-6 md:mb-20">
                        {data.map((programType) => (
                            <Button
                                key={programType.id}
                                variant={programType.name === 'Yrkesfag' ? 'primary' : 'secondary'}
                                size="large"
                                type="button"
                                className="karakterkalkulator_start w-full sm:w-auto min-w-52"
                                onClick={() => handleProgramTypeClick(programType)}
                            >
                                {programType.name === '23/5-regelen' ? (
                                    <span className="flex flex-col items-center leading-tight">
                                        <span style={{ fontSize: '0.75rem', fontWeight: 'normal' }}>Jeg bruker</span>
                                        <span>23/5-regelen</span>
                                    </span>
                                ) : (
                                    programType.name
                                )}
                            </Button>
                        ))}
                    </div>
                    <StoredResultsList />
                </Container>
            </section>
        </AppLayout>
    )
}
